import React, { Component } from 'react'
import { MenuItem, Dropdown } from 'react-bootstrap'
import { Link, browserHistory } from 'react-router'
import i18next from 'i18next'

import styles from './styles/app.scss'
import adminStyles from './styles/admin.scss'

import logo from './../assets/images/logo-inverse.svg'
import dropDownIcon from './../assets/images/arrow-down.svg'

export default class Navigation extends Component {
  handleSettingsClick = () => {
    browserHistory.push('/profile')
  }

  render() {
    const { currentAccount, currentOrganisation } = this.props

    return (
      <nav>
        <div className={adminStyles.navigation}>
          <div className={adminStyles.logoContainer}>
            <Link to="/">
              <img src={logo} className={styles.logo} />
            </Link>
          </div>

          <div className={adminStyles.navigationLinks}>
            <Link to="/support">{i18next.t('support')}</Link>

            {currentOrganisation.roles &&
              currentOrganisation.roles.indexOf('admin') !== -1 && (
                <Link to="/management">{i18next.t('management')}</Link>
              )}

            {currentAccount.isSuperAdmin && (
              <Link to="/admin">{i18next.t('super_admin_settings')}</Link>
            )}
          </div>

          <div className={adminStyles.profileMenu}>
            <Dropdown id="profile-menu" pullRight>
              <Dropdown.Toggle bsStyle="link" noCaret>
                <span className={adminStyles.profileMenuToggle}>{currentAccount.email}</span>

                <img src={dropDownIcon} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <MenuItem
                  header
                  style={{
                    marginTop: 10,
                    paddingBottom: 10,
                    borderBottom: '1px solid #eee'
                  }}
                >
                  {currentOrganisation.organisation.name}
                </MenuItem>

                <MenuItem eventKey="1" onClick={this.handleSettingsClick}>
                  {i18next.t('own_settings')}
                </MenuItem>

                <MenuItem eventKey="100" onClick={this.props.onLogout}>
                  {i18next.t('log_out')}
                </MenuItem>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Navigation.js